'use es6';

import * as RequestStates from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/FormDeletion';
const actionToState = {
  [Actions.RESET_FORM_DELETION_STATE]: RequestStates.NOT_REQUESTED,
  [Actions.REQUEST_FORM_DELETION]: RequestStates.REQUESTED,
  [Actions.SUCCEED_DELETING_FORM]: RequestStates.SUCCEEDED,
  [Actions.FAIL_DELETING_FORM]: RequestStates.FAILED
};
export function formDeletionState(state = RequestStates.NOT_REQUESTED, {
  type
}) {
  if (Object.prototype.hasOwnProperty.call(actionToState, type)) {
    return actionToState[type];
  }
  return state;
}